interface PopupOptions {
  width: number;
  height: number;
  windowName?: string;
  additionalOptions?: string;
}

const openCenteredPopup = (
  url: string,
  { width, height, windowName = '', additionalOptions = '' }: PopupOptions
) => {
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const screenWidth =
    window.innerWidth || document.documentElement.clientWidth || screen.width;
  const screenHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    screen.height;

  const left = screenWidth / 2 - width / 2 + dualScreenLeft;
  const top = screenHeight / 2 - height / 2 + dualScreenTop;

  const opts = `width=${width},height=${height},top=${top},left=${left},${additionalOptions}`;

  window.open(url, windowName, opts);
};

export default openCenteredPopup;
